// import React, { useState, useEffect, useRef, useCallback } from "react";
// import Header from "./Header.js";
// import Footer from "./Footer.js";
// import Select from "react-select";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./Style.css";
// import { TailSpin } from "react-loader-spinner";
// import Add_appointment from "../../Components/Admin_components/add_appointment.js";
// import Get_appointment_by_slot from "../../Components/Admin_components/get_slot_appointment_sheet.js";
// import Delete_appointment from "../../Components/Admin_components/delete_appointment.js";
// import Update_appointment from "../../Components/Admin_components/update_appointment.js";
// import Report from "../../Components/Admin_components/report.js";
// import "../../Api/apiUrls";
// import { getAdminAppointment, appointmentExcel } from "../../Api/apiUrls";

// const wrapText = (text, maxLength = 10) => {
//   if (!text) return "--";
//   return text
//     .split(" ")
//     .reduce((acc, word) => {
//       const lastLine = acc[acc.length - 1];
//       if ((lastLine + " " + word).length <= maxLength) {
//         acc[acc.length - 1] = lastLine + (lastLine ? " " : "") + word;
//       } else {
//         acc.push(word);
//       }
//       return acc;
//     }, [""])
//     .join("\n");
// };

// const formatDateTime = (dateTime) => {
//   const formattedDate = dateTime.toLocaleDateString("en-GB", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//   });

//   const formattedTime = dateTime.toLocaleTimeString("en-US", {
//     hour: "numeric",
//     minute: "numeric",
//     second: "numeric",
//   });

//   return `${formattedDate} ${formattedTime}`;
// };

// function Appointment() {
//   // Modal states
//   const [modalAdd_appointmentIsOpen, setAdd_appointmentModalIsOpen] = useState(false);
//   const [modalGet_appointment_by_slotIsOpen, setGet_appointment_by_slotModalIsOpen] = useState(false);
//   const [modalDelete_appointmentIsOpen, setDelete_appointmentIsOpen] = useState(false);
//   const [modalUpdate_appointmentIsOpen, setUpdate_appointmentModalIsOpen] = useState(false);
//   const [modalReportIsOpen, setReportModalIsOpen] = useState(false);
  
//   // Selected items for modals
//   const [selectedUserId, setSelectedUserId] = useState(null);
  
//   // Filter and search states
//   const [selectedStatus, setSelectedStatus] = useState({ value: "All", label: "All" });
//   const [selectedType, setSelectedType] = useState({ value: "All", label: "All" });
//   const [searchQuery, setSearchQuery] = useState("");
//   const [appliedSearchQuery, setAppliedSearchQuery] = useState("");
  
//   // Data states
//   const [appointments, setAppointments] = useState([]);
//   const [totalItems, setTotalItems] = useState(0);
//   const [pagination, setPagination] = useState({ current_page: 1, total_pages: 1 });
  
//   // Loading states
//   const [isLoading, setIsLoading] = useState(true);
//   const [isFetching, setIsFetching] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const [page, setPage] = useState(1);

//   const observer = useRef();
//   const searchInputRef = useRef();

//   // Filter options
//   const type = [
//     { value: "All", label: "All" },
//     { value: "Workshop", label: "Workshop" },
//     { value: "Venue", label: "Venue" },
//   ];

//   const status = [
//     { value: "All", label: "All" },
//     { value: "Active", label: "Active" },
//     { value: "Completed", label: "Completed" },
//     { value: "Cancelled", label: "Cancelled" },
//     { value: "Reviewing", label: "Reviewing" },
//   ];

//   // Modal handlers
//   const openReport = (userId) => {
//     setSelectedUserId(userId);
//     setReportModalIsOpen(true);
//   };

//   const closeReport = () => {
//     setReportModalIsOpen(false);
//   };

//   const openAdd_appointment = () => {
//     setAdd_appointmentModalIsOpen(true);
//   };

//   const closeAdd_appointment = () => {
//     setAdd_appointmentModalIsOpen(false);
//   };

//   const openGet_appointment_by_slot = () => {
//     setGet_appointment_by_slotModalIsOpen(true);
//   };

//   const closeGet_appointment_by_slot = () => {
//     setGet_appointment_by_slotModalIsOpen(false);
//   };

//   const openUpdate_appointment = () => {
//     setUpdate_appointmentModalIsOpen(true);
//   };

//   const closeUpdate_appointment = () => {
//     setUpdate_appointmentModalIsOpen(false);
//   };

//   const openDelete_appointment = (userId) => {
//     setSelectedUserId(userId);
//     setDelete_appointmentIsOpen(true);
//   };

//   const closeDelete_appointment = () => {
//     setDelete_appointmentIsOpen(false);
//   };

//   // Filter handlers
//   const handleStatusChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setPage(1);
//     setAppointments([]);
//   };

//   const handleTypeChange = (selectedOption) => {
//     setSelectedType(selectedOption);
//     setPage(1);
//     setAppointments([]);
//   };

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const handleSearchSubmit = () => {
//     setAppliedSearchQuery(searchQuery);
//     setPage(1);
//     setAppointments([]);
//   };

//   const handleKeyPress = (event) => {
//     if (event.key === 'Enter') {
//       handleSearchSubmit();
//     }
//   };

//   const clearSearch = () => {
//     setSearchQuery("");
//     setAppliedSearchQuery("");
//     setPage(1);
//     setAppointments([]);
//   };

//   // Build API query parameters
//   const buildQueryParams = useCallback((pageNum) => {
//     const params = new URLSearchParams();
//     params.append('page', pageNum);
//     params.append('page_size', 50);
    
//     if (appliedSearchQuery) params.append('search', appliedSearchQuery);
//     if (selectedStatus.value !== 'All') params.append('status', selectedStatus.value);
//     if (selectedType.value !== 'All') params.append('type', selectedType.value);
    
//     return params.toString();
//   }, [appliedSearchQuery, selectedStatus, selectedType]);

//   // Fetch data with pagination
//   const fetchAppointments = useCallback(async (pageNum = 1) => {
//     if (pageNum > pagination.total_pages && pagination.total_pages > 0) {
//       setHasMore(false);
//       return;
//     }
    
//     setIsFetching(true);
//     try {
//       const queryParams = buildQueryParams(pageNum);
//       const response = await fetch(`${getAdminAppointment}?${queryParams}`);
//       if (!response.ok) throw new Error("Network response was not ok");
      
//       const data = await response.json();
//       const newAppointments = data.data.Appointment || [];
      
//       if (pageNum === 1) {
//         setAppointments(newAppointments);
//         setPagination(data.data.pagination || { current_page: 1, total_pages: 1 });
//         setTotalItems(data.data.pagination?.total_items || 0);
//       } else {
//         setAppointments(prev => [...prev, ...newAppointments]);
//       }
      
//       setHasMore(pageNum < data.data.pagination?.total_pages);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setIsFetching(false);
//       setIsLoading(false);
//     }
//   }, [buildQueryParams, pagination.total_pages]);

//   useEffect(() => {
//     fetchAppointments(page);
//   }, [page, fetchAppointments]);

//   // Infinite scroll observer
//   const lastAppointmentElementRef = useCallback(node => {
//     if (isFetching || !hasMore) return;
//     if (observer.current) observer.current.disconnect();
//     observer.current = new IntersectionObserver(entries => {
//       if (entries[0].isIntersecting) {
//         setPage(prev => prev + 1);
//       }
//     });
//     if (node) observer.current.observe(node);
//   }, [isFetching, hasMore]);

//   const convertTimeTo12HourFormat = (time24hr) => {
//     if (!time24hr || typeof time24hr !== 'string' || !time24hr.includes(" - ")) {
//       return "--";
//     }

//     const [start, end] = time24hr.split(" - ");

//     const convertTo12HourFormat = (time) => {
//       const [hour, minutes] = time.split(":");
//       const isPM = parseInt(hour, 10) >= 12;

//       const convertedHour = isPM ? (parseInt(hour, 10) % 12 || 12) : (parseInt(hour, 10) || 12);
//       const period = isPM ? "PM" : "AM";

//       return `${convertedHour}:${minutes} ${period}`;
//     };

//     const convertedStart = convertTo12HourFormat(start);
//     const convertedEnd = convertTo12HourFormat(end);

//     return `${convertedStart} - ${convertedEnd}`;
//   };

//   const formatCreatedAt = (createdAt) => {
//     if (!createdAt) return "--";
//     const createdAtDate = new Date(createdAt);
//     if (isNaN(createdAtDate)) return "--";
    
//     const datePart = createdAtDate.toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
    
//     const timePart = createdAtDate.toLocaleTimeString("en-GB", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
    
//     return `${datePart} - ${timePart}`;
//   };

//   const handleDownloadClick = () => {
//     window.open(appointmentExcel, "_blank");
//   };

//   return (
//     <div>
//       <Header></Header>
//       {modalAdd_appointmentIsOpen && (
//         <Add_appointment onClose={closeAdd_appointment} />
//       )}
//       {modalGet_appointment_by_slotIsOpen && (
//         <Get_appointment_by_slot onClose={closeGet_appointment_by_slot} />
//       )}
//       {modalDelete_appointmentIsOpen && (
//         <Delete_appointment
//           userId={selectedUserId}
//           onClose={closeDelete_appointment}
//         />
//       )}
//       {modalUpdate_appointmentIsOpen && (
//         <Update_appointment onClose={closeUpdate_appointment} />
//       )}
//       {modalReportIsOpen && (
//         <Report userId={selectedUserId} onClose={closeReport} />
//       )}
//       <main id="main" className="main">
//         <div className="pagetitle">
//           <h1>Appointment</h1>
//         </div>
//         <section className="section">
//           <div className="card p-2">
//             <div className="parent col-md-12 row mt-2">
//               <div className="row">
//                 <div className="child col-md-2" style={{ padding: "5px" }}>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       ref={searchInputRef}
//                       style={{
//                         borderRadius: "5px",
//                         height: "37px",
//                         padding: "10px",
//                         border: "1px solid lightgrey ",
//                         width: "100%",
//                       }}
//                       onChange={handleSearchChange}
//                       onKeyPress={handleKeyPress}
//                       value={searchQuery}
//                       placeholder="Search..."
//                     />
//                     {searchQuery && (
//                       <button 
//                         className="btn btn-outline-secondary" 
//                         type="button"
//                         onClick={clearSearch}
//                         style={{ marginLeft: '5px' }}
//                       >
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                     <button 
//                       className="btn btn-primary" 
//                       type="button"
//                       onClick={handleSearchSubmit}
//                       style={{ marginLeft: '5px' }}
//                     >
//                       Search
//                     </button>
//                   </div>
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <Select
//                     options={type}
//                     placeholder="Select Type"
//                     value={selectedType}
//                     onChange={handleTypeChange}
//                   />
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <Select
//                     options={status}
//                     placeholder="Select Status"
//                     value={selectedStatus}
//                     onChange={handleStatusChange}
//                   />
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <button
//                     id="btnNewUser"
//                     type="button"
//                     className="btn-round"
//                     onClick={openAdd_appointment}
//                   >
//                     <i className="bi bi-person-add"></i> Add Appointment
//                   </button>
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <button
//                     id="btnDownloadSlotAppointment"
//                     type="button"
//                     className="btn-round"
//                     onClick={openGet_appointment_by_slot}
//                   >
//                     <i className="bi bi-download"></i> Get Slot Appointment
//                   </button>
//                 </div>
//                 <div
//                   className="col-md-2"
//                   style={{ cursor: "pointer", padding: '5px' }}
//                   onClick={handleDownloadClick}
//                 >
//                   Download
//                   <i
//                     style={{ fontSize: "20px", marginLeft: "10px" }}
//                     className="bi bi-download"
//                   ></i>
//                 </div>
//               </div>
//             </div>

//             <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
//               {isLoading ? (
//                 <div style={{ marginTop: "50px", marginLeft: "50%" }}>
//                   <TailSpin color="black" width={50} />
//                 </div>
//               ) : appointments.length > 0 ? (
//                 <table className="table table-striped">
//                   <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
//                     <tr>
//                       <th scope="col">Sr.No</th>
//                       <th scope="col">Name</th>
//                       <th scope="col">Type</th>
//                       <th scope="col">Gift</th>
//                       <th scope="col">Appointment Date/Slot</th>
//                       <th scope="col">Customer Details</th>
//                       <th scope="col">Pass Details</th>
//                       <th scope="col">Instructor/Venue Owner Details</th>
//                       <th scope="col">Payment Amount</th>
//                       <th scope="col">Booking Date Time</th>
//                       <th scope="col">Status</th>
//                       <th scope="col">Cancellation Reason</th>
//                       <th scope="col">Report</th>
//                       <th scope="col">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody id="tableBody">
//                     {appointments.map((appointment, index) => (
//                       <tr 
//                         key={`${appointment.id}-${index}`}
//                         ref={index === appointments.length - 1 ? lastAppointmentElementRef : null}
//                       >
//                         <th scope="row">{(pagination.current_page - 1) * 50 + index + 1}</th>
//                         <td>
//                           {appointment.type === "Venue" ? (
//                             <>{appointment.bookingSlot?.venue.name || "--"}</>
//                           ) : (
//                             <>
//                               {appointment.workshopSlot?.workshop.name || "--"}
//                             </>
//                           )}
//                           <br />
//                         </td>
//                         <td>
//                           {appointment.type || "--"}
//                           <br />
//                         </td>
//                         <td>
//                           {appointment.gift?.name
//                             ? appointment.gift.name.split(",").map((word, index) => (
//                                 <span key={index}>
//                                   {word}
//                                   <br />
//                                 </span>
//                               ))
//                             : "--"}
//                           <br />
//                           {appointment.gift?.mobileNumber
//                             ? appointment.gift.mobileNumber.split(",").map((word, index) => (
//                                 <span key={index}>
//                                   {word}
//                                   <br />
//                                 </span>
//                               ))
//                             : "--"}
//                           <br />
//                           {appointment.gift?.email
//                             ? appointment.gift.email.split(",").map((word, index) => (
//                                 <span key={index}>
//                                   {word}
//                                   <br />
//                                 </span>
//                               ))
//                             : "--"}
//                           <br />
//                         </td>
//                         <td>
//                           Date:
//                           {appointment.type === "Workshop" ? (
//                             <>
//                               {formatCreatedAt(
//                                 appointment.workshopSlot?.date || "--"
//                               )}
//                             </>
//                           ) : (
//                             <>
//                               {formatCreatedAt(
//                                 appointment.bookingSlot?.startDate || "--"
//                               )}
//                             </>
//                           )}
//                           <br />
//                           Slot:{" "}
//                           {convertTimeTo12HourFormat(appointment?.slot || "--")}
//                           <br />
//                           <br />
//                         </td>
//                         <td>
//                           {appointment.user.name || "--"}
//                           <br />
//                           {appointment.user.email || "--"}
//                           <br />
//                           {appointment.user.mobileNumber || "--"}
//                         </td>
//                         <td>
//                           {appointment.passes?.title || "--"}
//                           <br />
//                           {appointment.passes?.duration_type || "--"}
//                         </td>
//                         <td>
//                           {appointment.type === "Workshop" ? (
//                             <>
//                               {appointment.workshopSlot?.workshop
//                                 .workshopInstructor.name || "--"}
//                               <br />
//                               {appointment.workshopSlot?.workshop
//                                 .workshopInstructor.email || "--"}
//                               <br />
//                               {appointment.workshopSlot?.workshop
//                                 .workshopInstructor.mobileNumber || "--"}
//                             </>
//                           ) : (
//                             <>
//                               {appointment.bookingSlot?.venue.venue_owner
//                                 .name || "--"}
//                               <br />
//                               {appointment.bookingSlot?.venue.venue_owner
//                                 .email || "--"}
//                               <br />
//                               {appointment.bookingSlot?.venue.venue_owner
//                                 .mobileNumber || "--"}
//                             </>
//                           )}
//                         </td>
//                         <td>
//                           {appointment.transaction?.amount || appointment?.price || "--"}
//                         </td>
//                         <td>
//                           {formatDateTime(new Date(appointment.created_at))}
//                         </td>
//                         <td>{appointment.status || "-"}</td>
//                         <td>{appointment.reasonOfCancellation || "-"}</td>
//                         <td> {appointment.report_text || "-"}</td>
//                         <td>
//                           <button
//                             id="btnNewUserCancel"
//                             type="button"
//                             className="btn-round"
//                             onClick={() => openReport(appointment.id)}
//                           >
//                             <i></i> Report
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               ) : (
//                 <h3 style={{ textAlign: "center" }}> No data available </h3>
//               )}

//               {isFetching && (
//                 <div className="text-center py-3">
//                   <TailSpin color="#0d6efd" width={50} />
//                 </div>
//               )}
//             </div>

//             <div className="p-3 bg-dark text-white rounded-bottom">
//               Showing {appointments.length} of {totalItems} total appointments
//               {hasMore && " - scroll to load more"}
//             </div>
//           </div>
//         </section>
//       </main>
//       <Footer></Footer>
//     </div>
//   );
// }

// export default Appointment;

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import Header from "./Header.js";
// import Footer from "./Footer.js";
// import Select from "react-select";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./Style.css";
// import { TailSpin } from "react-loader-spinner";
// import Add_appointment from "../../Components/Admin_components/add_appointment.js";
// import Get_appointment_by_slot from "../../Components/Admin_components/get_slot_appointment_sheet.js";
// import Delete_appointment from "../../Components/Admin_components/delete_appointment.js";
// import Update_appointment from "../../Components/Admin_components/update_appointment.js";
// import Report from "../../Components/Admin_components/report.js";
// import "../../Api/apiUrls";
// import { getAdminAppointment, appointmentExcel } from "../../Api/apiUrls";

// const wrapText = (text, maxLength = 10) => {
//   if (!text) return "--";
//   return text
//     .split(" ")
//     .reduce((acc, word) => {
//       const lastLine = acc[acc.length - 1];
//       if ((lastLine + " " + word).length <= maxLength) {
//         acc[acc.length - 1] = lastLine + (lastLine ? " " : "") + word;
//       } else {
//         acc.push(word);
//       }
//       return acc;
//     }, [""])
//     .join("\n");
// };

// const formatDateTime = (dateTime) => {
//   const formattedDate = dateTime.toLocaleDateString("en-GB", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//   });

//   const formattedTime = dateTime.toLocaleTimeString("en-US", {
//     hour: "numeric",
//     minute: "numeric",
//     second: "numeric",
//   });

//   return `${formattedDate} ${formattedTime}`;
// };

// const isWithin7Days = (dateString) => {
//   if (!dateString) return false;
//   const slotDate = new Date(dateString);
//   const today = new Date();
//   const sevenDaysLater = new Date(today);
//   sevenDaysLater.setDate(today.getDate() + 7);
//   return slotDate >= today && slotDate <= sevenDaysLater;
// };

// const convertTimeTo12HourFormat = (time24hr) => {
//   if (!time24hr || typeof time24hr !== 'string' || !time24hr.includes(" - ")) {
//     return "--";
//   }

//   const [start, end] = time24hr.split(" - ");

//   const convertTo12HourFormat = (time) => {
//     const [hour, minutes] = time.split(":");
//     const isPM = parseInt(hour, 10) >= 12;

//     const convertedHour = isPM ? (parseInt(hour, 10) % 12 || 12) : (parseInt(hour, 10) || 12);
//     const period = isPM ? "PM" : "AM";

//     return `${convertedHour}:${minutes} ${period}`;
//   };

//   const convertedStart = convertTo12HourFormat(start);
//   const convertedEnd = convertTo12HourFormat(end);

//   return `${convertedStart} - ${convertedEnd}`;
// };

// const formatCreatedAt = (createdAt) => {
//   if (!createdAt) return "--";
//   const createdAtDate = new Date(createdAt);
//   if (isNaN(createdAtDate)) return "--";
  
//   const datePart = createdAtDate.toLocaleDateString("en-GB", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//   });
  
//   const timePart = createdAtDate.toLocaleTimeString("en-GB", {
//     hour: "numeric",
//     minute: "numeric",
//     hour12: true,
//   });
  
//   return `${datePart} - ${timePart}`;
// };

// function Appointment() {
//   const [modalAdd_appointmentIsOpen, setAdd_appointmentModalIsOpen] = useState(false);
//   const [modalGet_appointment_by_slotIsOpen, setGet_appointment_by_slotModalIsOpen] = useState(false);
//   const [modalDelete_appointmentIsOpen, setDelete_appointmentIsOpen] = useState(false);
//   const [modalUpdate_appointmentIsOpen, setUpdate_appointmentModalIsOpen] = useState(false);
//   const [modalReportIsOpen, setReportModalIsOpen] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [selectedStatus, setSelectedStatus] = useState({ value: "All", label: "All" });
//   const [selectedType, setSelectedType] = useState({ value: "All", label: "All" });
//   const [searchQuery, setSearchQuery] = useState("");
//   const [appliedSearchQuery, setAppliedSearchQuery] = useState("");
//   const [appointments, setAppointments] = useState([]);
//   const [totalItems, setTotalItems] = useState(0);
//   const [pagination, setPagination] = useState({ current_page: 1, total_pages: 1 });
//   const [isLoading, setIsLoading] = useState(true);
//   const [isFetching, setIsFetching] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const [page, setPage] = useState(1);

//   const observer = useRef();
//   const searchInputRef = useRef();

//   const type = [
//     { value: "All", label: "All" },
//     { value: "Workshop", label: "Workshop" },
//     { value: "Venue", label: "Venue" },
//   ];

//   const status = [
//     { value: "All", label: "All" },
//     { value: "Active", label: "Active" },
//     { value: "Completed", label: "Completed" },
//     { value: "Cancelled", label: "Cancelled" },
//     { value: "Reviewing", label: "Reviewing" },
//   ];

//   const openReport = (userId) => {
//     setSelectedUserId(userId);
//     setReportModalIsOpen(true);
//   };

//   const closeReport = () => {
//     setReportModalIsOpen(false);
//   };

//   const openAdd_appointment = () => {
//     setAdd_appointmentModalIsOpen(true);
//   };

//   const closeAdd_appointment = () => {
//     setAdd_appointmentModalIsOpen(false);
//   };

//   const openGet_appointment_by_slot = () => {
//     setGet_appointment_by_slotModalIsOpen(true);
//   };

//   const closeGet_appointment_by_slot = () => {
//     setGet_appointment_by_slotModalIsOpen(false);
//   };

//   const openUpdate_appointment = () => {
//     setUpdate_appointmentModalIsOpen(true);
//   };

//   const closeUpdate_appointment = () => {
//     setUpdate_appointmentModalIsOpen(false);
//   };

//   const openDelete_appointment = (userId) => {
//     setSelectedUserId(userId);
//     setDelete_appointmentIsOpen(true);
//   };

//   const closeDelete_appointment = () => {
//     setDelete_appointmentIsOpen(false);
//   };

//   const handleStatusChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setPage(1);
//     setAppointments([]);
//   };

//   const handleTypeChange = (selectedOption) => {
//     setSelectedType(selectedOption);
//     setPage(1);
//     setAppointments([]);
//   };

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//   };

//   const handleSearchSubmit = () => {
//     setAppliedSearchQuery(searchQuery);
//     setPage(1);
//     setAppointments([]);
//   };

//   const handleKeyPress = (event) => {
//     if (event.key === 'Enter') {
//       handleSearchSubmit();
//     }
//   };

//   const clearSearch = () => {
//     setSearchQuery("");
//     setAppliedSearchQuery("");
//     setPage(1);
//     setAppointments([]);
//   };

//   const buildQueryParams = useCallback((pageNum) => {
//     const params = new URLSearchParams();
//     params.append('page', pageNum);
//     params.append('page_size', 50);
    
//     if (appliedSearchQuery) params.append('search', appliedSearchQuery);
//     if (selectedStatus.value !== 'All') params.append('status', selectedStatus.value);
//     if (selectedType.value !== 'All') params.append('type', selectedType.value);
    
//     return params.toString();
//   }, [appliedSearchQuery, selectedStatus, selectedType]);

//   const fetchAppointments = useCallback(async (pageNum = 1) => {
//     if (pageNum > pagination.total_pages && pagination.total_pages > 0) {
//       setHasMore(false);
//       return;
//     }
    
//     setIsFetching(true);
//     try {
//       const queryParams = buildQueryParams(pageNum);
//       const response = await fetch(`${getAdminAppointment}?${queryParams}`);
//       if (!response.ok) throw new Error("Network response was not ok");
      
//       const data = await response.json();
//       const newAppointments = data.data.Appointment || [];
      
//       if (pageNum === 1) {
//         setAppointments(newAppointments);
//         setPagination(data.data.pagination || { current_page: 1, total_pages: 1 });
//         setTotalItems(data.data.pagination?.total_items || 0);
//       } else {
//         setAppointments(prev => [...prev, ...newAppointments]);
//       }
      
//       setHasMore(pageNum < data.data.pagination?.total_pages);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setIsFetching(false);
//       setIsLoading(false);
//     }
//   }, [buildQueryParams, pagination.total_pages]);

//   useEffect(() => {
//     fetchAppointments(page);
//   }, [page, fetchAppointments]);

//   const lastAppointmentElementRef = useCallback(node => {
//     if (isFetching || !hasMore) return;
//     if (observer.current) observer.current.disconnect();
//     observer.current = new IntersectionObserver(entries => {
//       if (entries[0].isIntersecting) {
//         setPage(prev => prev + 1);
//       }
//     });
//     if (node) observer.current.observe(node);
//   }, [isFetching, hasMore]);

//   const handleDownloadClick = () => {
//     window.open(appointmentExcel, "_blank");
//   };

//   return (
//     <div>
//       <Header></Header>
//       {modalAdd_appointmentIsOpen && (
//         <Add_appointment onClose={closeAdd_appointment} />
//       )}
//       {modalGet_appointment_by_slotIsOpen && (
//         <Get_appointment_by_slot onClose={closeGet_appointment_by_slot} />
//       )}
//       {modalDelete_appointmentIsOpen && (
//         <Delete_appointment
//           userId={selectedUserId}
//           onClose={closeDelete_appointment}
//         />
//       )}
//       {modalUpdate_appointmentIsOpen && (
//         <Update_appointment onClose={closeUpdate_appointment} />
//       )}
//       {modalReportIsOpen && (
//         <Report userId={selectedUserId} onClose={closeReport} />
//       )}
//       <main id="main" className="main">
//         <div className="pagetitle">
//           <h1>Appointment</h1>
//         </div>
//         <section className="section">
//           <div className="card p-2">
//             <div className="parent col-md-12 row mt-2">
//               <div className="row">
//                 <div className="child col-md-2" style={{ padding: "5px" }}>
//                   <div className="input-group">
//                     <input
//                       type="text"
//                       ref={searchInputRef}
//                       style={{
//                         borderRadius: "5px",
//                         height: "37px",
//                         padding: "10px",
//                         border: "1px solid lightgrey ",
//                         width: "100%",
//                       }}
//                       onChange={handleSearchChange}
//                       onKeyPress={handleKeyPress}
//                       value={searchQuery}
//                       placeholder="Search..."
//                     />
//                     {searchQuery && (
//                       <button 
//                         className="btn btn-outline-secondary" 
//                         type="button"
//                         onClick={clearSearch}
//                         style={{ marginLeft: '5px' }}
//                       >
//                         <i className="bi bi-x"></i>
//                       </button>
//                     )}
//                     <button 
//                       className="btn btn-primary" 
//                       type="button"
//                       onClick={handleSearchSubmit}
//                       style={{ marginLeft: '5px' }}
//                     >
//                       Search
//                     </button>
//                   </div>
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <Select
//                     options={type}
//                     placeholder="Select Type"
//                     value={selectedType}
//                     onChange={handleTypeChange}
//                   />
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <Select
//                     options={status}
//                     placeholder="Select Status"
//                     value={selectedStatus}
//                     onChange={handleStatusChange}
//                   />
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <button
//                     id="btnNewUser"
//                     type="button"
//                     className="btn-round"
//                     onClick={openAdd_appointment}
//                   >
//                     <i className="bi bi-person-add"></i> Add Appointment
//                   </button>
//                 </div>
//                 <div className="col-md-2" style={{ padding: "5px" }}>
//                   <button
//                     id="btnDownloadSlotAppointment"
//                     type="button"
//                     className="btn-round"
//                     onClick={openGet_appointment_by_slot}
//                   >
//                     <i className="bi bi-download"></i> Get Slot Appointment
//                   </button>
//                 </div>
//                 <div
//                   className="col-md-2"
//                   style={{ cursor: "pointer", padding: '5px' }}
//                   onClick={handleDownloadClick}
//                 >
//                   Download
//                   <i
//                     style={{ fontSize: "20px", marginLeft: "10px" }}
//                     className="bi bi-download"
//                   ></i>
//                 </div>
//               </div>
//             </div>

//             <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
//               {isLoading ? (
//                 <div style={{ marginTop: "50px", marginLeft: "50%" }}>
//                   <TailSpin color="black" width={50} />
//                 </div>
//               ) : appointments.length > 0 ? (
//                 <table className="table table-striped">
//                   <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
//                     <tr>
//                       <th scope="col">Sr.No</th>
//                       <th scope="col">Name</th>
//                       <th scope="col">Type</th>
//                       <th scope="col">Gift</th>
//                       <th scope="col">Appointment Date/Slot</th>
//                       <th scope="col">Customer Details</th>
//                       <th scope="col">Pass Details</th>
//                       <th scope="col">Instructor/Venue Owner Details</th>
//                       <th scope="col">Payment Amount</th>
//                       <th scope="col">Booking Date Time</th>
//                       <th scope="col">Status</th>
//                       <th scope="col">Source</th>
//                       <th scope="col">Attended</th>
//                       <th scope="col">Cancellation Reason</th>
//                       <th scope="col">Report</th>
//                       <th scope="col">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody id="tableBody">
//                     {appointments.map((appointment, index) => (
//                       <tr 
//                         key={`${appointment.id}-${index}`}
//                         ref={index === appointments.length - 1 ? lastAppointmentElementRef : null}
//                         style={{
//                             backgroundColor:
//                               !appointment.attended &&
//                               isWithin7Days(
//                                 appointment.type === "Workshop"
//                                   ? appointment.workshopSlot?.date
//                                   : appointment.bookingSlot?.startDate
//                               )
//                                 ? 'rgba(255, 255, 0, 0.2)'
//                                 : 'inherit'
//                           }}
//                       >
//                         <th scope="row">{(pagination.current_page - 1) * 50 + index + 1}</th>
//                         <td>
//                           {appointment.type === "Venue" ? (
//                             <>{appointment.bookingSlot?.venue.name || "--"}</>
//                           ) : (
//                             <>
//                               {appointment.workshopSlot?.workshop.name || "--"}
//                             </>
//                           )}
//                           <br />
//                         </td>
//                         <td>
//                           {appointment.type || "--"}
//                           <br />
//                         </td>
//                         <td>
//                           {appointment.gift?.name
//                             ? appointment.gift.name.split(",").map((word, index) => (
//                                 <span key={index}>
//                                   {word}
//                                   <br />
//                                 </span>
//                               ))
//                             : "--"}
//                           <br />
//                           {appointment.gift?.mobileNumber
//                             ? appointment.gift.mobileNumber.split(",").map((word, index) => (
//                                 <span key={index}>
//                                   {word}
//                                   <br />
//                                 </span>
//                               ))
//                             : "--"}
//                           <br />
//                           {appointment.gift?.email
//                             ? appointment.gift.email.split(",").map((word, index) => (
//                                 <span key={index}>
//                                   {word}
//                                   <br />
//                                 </span>
//                               ))
//                             : "--"}
//                           <br />
//                         </td>
//                         <td>
//                           Date:
//                           {appointment.type === "Workshop" ? (
//                             <>
//                               {formatCreatedAt(
//                                 appointment.workshopSlot?.date || "--"
//                               )}
//                             </>
//                           ) : (
//                             <>
//                               {formatCreatedAt(
//                                 appointment.bookingSlot?.startDate || "--"
//                               )}
//                             </>
//                           )}
//                           <br />
//                           Slot:{" "}
//                           {convertTimeTo12HourFormat(appointment?.slot || "--")}
//                           <br />
//                           <br />
//                         </td>
//                         <td>
//                           {appointment.user.name || "--"}
//                           <br />
//                           {appointment.user.email || "--"}
//                           <br />
//                           {appointment.user.mobileNumber || "--"}
//                         </td>
//                         <td>
//                           {appointment.passes?.title || "--"}
//                           <br />
//                           {appointment.passes?.duration_type || "--"}
//                         </td>
//                         <td>
//                           {appointment.type === "Workshop" ? (
//                             <>
//                               {appointment.workshopSlot?.workshop
//                                 .workshopInstructor.name || "--"}
//                               <br />
//                               {appointment.workshopSlot?.workshop
//                                 .workshopInstructor.email || "--"}
//                               <br />
//                               {appointment.workshopSlot?.workshop
//                                 .workshopInstructor.mobileNumber || "--"}
//                             </>
//                           ) : (
//                             <>
//                               {appointment.bookingSlot?.venue.venue_owner
//                                 .name || "--"}
//                               <br />
//                               {appointment.bookingSlot?.venue.venue_owner
//                                 .email || "--"}
//                               <br />
//                               {appointment.bookingSlot?.venue.venue_owner
//                                 .mobileNumber || "--"}
//                             </>
//                           )}
//                         </td>
//                         <td>
//                           {appointment.transaction?.amount || appointment?.price || "--"}
//                         </td>
//                         <td>
//                           {formatDateTime(new Date(appointment.created_at))}
//                         </td>
//                         <td style={{
//                           color: appointment.status === "Active" ? 'green' : 'red',
//                           fontWeight: 'bold'
//                         }}>
//                           {appointment.status || "-"}
//                         </td>
//                         <td>
//                           {appointment.source || "Website"}
//                         </td>
//                         <td>
//                           {appointment.status !== "Active" && (
//                             <span
//                               style={{
//                                 color: appointment.attended
//                                   ? 'green'
//                                   : appointment.not_attended
//                                   ? 'red'
//                                   : 'black',
//                                 fontWeight: 'bold'
//                               }}
//                             >
//                               {appointment.attended
//                                 ? 'Attended'
//                                 : appointment.not_attended
//                                 ? 'Absent'
//                                 : '-'}
//                             </span>
//                           )}
//                         </td>
//                         <td>{appointment.reasonOfCancellation || "-"}</td>
//                         <td> {appointment.report_text || "-"}</td>
//                         <td>
//                           <button
//                             id="btnNewUserCancel"
//                             type="button"
//                             className="btn-round"
//                             onClick={() => openReport(appointment.id)}
//                           >
//                             <i></i> Report
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               ) : (
//                 <h3 style={{ textAlign: "center" }}> No data available </h3>
//               )}

//               {isFetching && (
//                 <div className="text-center py-3">
//                   <TailSpin color="#0d6efd" width={50} />
//                 </div>
//               )}
//             </div>

//             <div className="p-3 bg-dark text-white rounded-bottom">
//               Showing {appointments.length} of {totalItems} total appointments
//               {hasMore && " - scroll to load more"}
//             </div>
//           </div>
//         </section>
//       </main>
//       <Footer></Footer>
//     </div>
//   );
// }

// export default Appointment;

import React, { useState, useEffect, useRef, useCallback } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import { TailSpin } from "react-loader-spinner";
import Add_appointment from "../../Components/Admin_components/add_appointment.js";
import Get_appointment_by_slot from "../../Components/Admin_components/get_slot_appointment_sheet.js";
import Delete_appointment from "../../Components/Admin_components/delete_appointment.js";
import Update_appointment from "../../Components/Admin_components/update_appointment.js";
import Report from "../../Components/Admin_components/report.js";
import Reschedule from "../../Components/Admin_components/reschedule.js";
import "../../Api/apiUrls";
import { getAdminAppointment, appointmentExcel } from "../../Api/apiUrls";

const wrapText = (text, maxLength = 10) => {
  if (!text) return "--";
  return text
    .split(" ")
    .reduce((acc, word) => {
      const lastLine = acc[acc.length - 1];
      if ((lastLine + " " + word).length <= maxLength) {
        acc[acc.length - 1] = lastLine + (lastLine ? " " : "") + word;
      } else {
        acc.push(word);
      }
      return acc;
    }, [""])
    .join("\n");
};

const formatDateTime = (dateTime) => {
  const formattedDate = dateTime.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  const formattedTime = dateTime.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });

  return `${formattedDate} ${formattedTime}`;
};

const isWithin7Days = (dateString) => {
  if (!dateString) return false;
  const slotDate = new Date(dateString);
  const today = new Date();
  const sevenDaysLater = new Date(today);
  sevenDaysLater.setDate(today.getDate() + 7);
  return slotDate >= today && slotDate <= sevenDaysLater;
};

const convertTimeTo12HourFormat = (time24hr) => {
  if (!time24hr || typeof time24hr !== 'string' || !time24hr.includes(" - ")) {
    return "--";
  }

  const [start, end] = time24hr.split(" - ");

  const convertTo12HourFormat = (time) => {
    const [hour, minutes] = time.split(":");
    const isPM = parseInt(hour, 10) >= 12;

    const convertedHour = isPM ? (parseInt(hour, 10) % 12 || 12) : (parseInt(hour, 10) || 12);
    const period = isPM ? "PM" : "AM";

    return `${convertedHour}:${minutes} ${period}`;
  };

  const convertedStart = convertTo12HourFormat(start);
  const convertedEnd = convertTo12HourFormat(end);

  return `${convertedStart} - ${convertedEnd}`;
};

const formatCreatedAt = (createdAt) => {
  if (!createdAt) return "--";
  const createdAtDate = new Date(createdAt);
  if (isNaN(createdAtDate)) return "--";
  
  const datePart = createdAtDate.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  
  const timePart = createdAtDate.toLocaleTimeString("en-GB", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  
  return `${datePart} - ${timePart}`;
};

function Appointment() {
  const [modalAdd_appointmentIsOpen, setAdd_appointmentModalIsOpen] = useState(false);
  const [modalGet_appointment_by_slotIsOpen, setGet_appointment_by_slotModalIsOpen] = useState(false);
  const [modalDelete_appointmentIsOpen, setDelete_appointmentIsOpen] = useState(false);
  const [modalUpdate_appointmentIsOpen, setUpdate_appointmentModalIsOpen] = useState(false);
  const [modalReportIsOpen, setReportModalIsOpen] = useState(false);
  const [modalRescheduleIsOpen, setRescheduleModalIsOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState({ value: "All", label: "All" });
  const [selectedType, setSelectedType] = useState({ value: "All", label: "All" });
  const [searchQuery, setSearchQuery] = useState("");
  const [appliedSearchQuery, setAppliedSearchQuery] = useState("");
  const [appointments, setAppointments] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState({ current_page: 1, total_pages: 1 });
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const observer = useRef();
  const searchInputRef = useRef();

  const type = [
    { value: "All", label: "All" },
    { value: "Workshop", label: "Workshop" },
    { value: "Venue", label: "Venue" },
  ];

  const status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Completed", label: "Completed" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "Reviewing", label: "Reviewing" },
    { value: "Rescheduled", label: "Rescheduled" },
  ];

  const openReport = (userId) => {
    setSelectedUserId(userId);
    setReportModalIsOpen(true);
  };

  const closeReport = () => {
    setReportModalIsOpen(false);
  };

  const openReschedule = (userId) => {
    setSelectedUserId(userId);
    setRescheduleModalIsOpen(true);
  };

  const closeReschedule = () => {
    setRescheduleModalIsOpen(false);
  };

  const openAdd_appointment = () => {
    setAdd_appointmentModalIsOpen(true);
  };

  const closeAdd_appointment = () => {
    setAdd_appointmentModalIsOpen(false);
  };

  const openGet_appointment_by_slot = () => {
    setGet_appointment_by_slotModalIsOpen(true);
  };

  const closeGet_appointment_by_slot = () => {
    setGet_appointment_by_slotModalIsOpen(false);
  };

  const openUpdate_appointment = () => {
    setUpdate_appointmentModalIsOpen(true);
  };

  const closeUpdate_appointment = () => {
    setUpdate_appointmentModalIsOpen(false);
  };

  const openDelete_appointment = (userId) => {
    setSelectedUserId(userId);
    setDelete_appointmentIsOpen(true);
  };

  const closeDelete_appointment = () => {
    setDelete_appointmentIsOpen(false);
  };

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setPage(1);
    setAppointments([]);
  };

  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption);
    setPage(1);
    setAppointments([]);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearchSubmit = () => {
    setAppliedSearchQuery(searchQuery);
    setPage(1);
    setAppointments([]);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchSubmit();
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setAppliedSearchQuery("");
    setPage(1);
    setAppointments([]);
  };

  const buildQueryParams = useCallback((pageNum) => {
    const params = new URLSearchParams();
    params.append('page', pageNum);
    params.append('page_size', 50);
    
    if (appliedSearchQuery) params.append('search', appliedSearchQuery);
    if (selectedStatus.value !== 'All') params.append('status', selectedStatus.value);
    if (selectedType.value !== 'All') params.append('type', selectedType.value);
    
    return params.toString();
  }, [appliedSearchQuery, selectedStatus, selectedType]);

  const fetchAppointments = useCallback(async (pageNum = 1) => {
    if (pageNum > pagination.total_pages && pagination.total_pages > 0) {
      setHasMore(false);
      return;
    }
    
    setIsFetching(true);
    try {
      const queryParams = buildQueryParams(pageNum);
      const response = await fetch(`${getAdminAppointment}?${queryParams}`);
      if (!response.ok) throw new Error("Network response was not ok");
      
      const data = await response.json();
      const newAppointments = data.data.Appointment || [];
      
      if (pageNum === 1) {
        setAppointments(newAppointments);
        setPagination(data.data.pagination || { current_page: 1, total_pages: 1 });
        setTotalItems(data.data.pagination?.total_items || 0);
      } else {
        setAppointments(prev => [...prev, ...newAppointments]);
      }
      
      setHasMore(pageNum < data.data.pagination?.total_pages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  }, [buildQueryParams, pagination.total_pages]);

  useEffect(() => {
    fetchAppointments(page);
  }, [page, fetchAppointments]);

  const lastAppointmentElementRef = useCallback(node => {
    if (isFetching || !hasMore) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setPage(prev => prev + 1);
      }
    });
    if (node) observer.current.observe(node);
  }, [isFetching, hasMore]);

  const handleDownloadClick = () => {
    window.open(appointmentExcel, "_blank");
  };

  return (
    <div>
      <Header></Header>
      {modalAdd_appointmentIsOpen && (
        <Add_appointment onClose={closeAdd_appointment} />
      )}
      {modalGet_appointment_by_slotIsOpen && (
        <Get_appointment_by_slot onClose={closeGet_appointment_by_slot} />
      )}
      {modalDelete_appointmentIsOpen && (
        <Delete_appointment
          userId={selectedUserId}
          onClose={closeDelete_appointment}
        />
      )}
      {modalUpdate_appointmentIsOpen && (
        <Update_appointment onClose={closeUpdate_appointment} />
      )}
      {modalReportIsOpen && (
        <Report userId={selectedUserId} onClose={closeReport} />
      )}
      {modalRescheduleIsOpen && (
        <Reschedule appointmentId={selectedUserId} onClose={closeReschedule} />
      )}
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Appointment</h1>
        </div>
        <section className="section">
          <div className="card p-2">
            <div className="parent col-md-12 row mt-2">
              <div className="row">
                <div className="child col-md-2" style={{ padding: "5px" }}>
                  <div className="input-group">
                    <input
                      type="text"
                      ref={searchInputRef}
                      style={{
                        borderRadius: "5px",
                        height: "37px",
                        padding: "10px",
                        border: "1px solid lightgrey ",
                        width: "100%",
                      }}
                      onChange={handleSearchChange}
                      onKeyPress={handleKeyPress}
                      value={searchQuery}
                      placeholder="Search..."
                    />
                    {searchQuery && (
                      <button 
                        className="btn btn-outline-secondary" 
                        type="button"
                        onClick={clearSearch}
                        style={{ marginLeft: '5px' }}
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                    <button 
                      className="btn btn-primary" 
                      type="button"
                      onClick={handleSearchSubmit}
                      style={{ marginLeft: '5px' }}
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div className="col-md-2" style={{ padding: "5px" }}>
                  <Select
                    options={type}
                    placeholder="Select Type"
                    value={selectedType}
                    onChange={handleTypeChange}
                  />
                </div>
                <div className="col-md-2" style={{ padding: "5px" }}>
                  <Select
                    options={status}
                    placeholder="Select Status"
                    value={selectedStatus}
                    onChange={handleStatusChange}
                  />
                </div>
                <div className="col-md-2" style={{ padding: "5px" }}>
                  <button
                    id="btnNewUser"
                    type="button"
                    className="btn-round"
                    onClick={openAdd_appointment}
                  >
                    <i className="bi bi-person-add"></i> Add Appointment
                  </button>
                </div>
                <div className="col-md-2" style={{ padding: "5px" }}>
                  <button
                    id="btnDownloadSlotAppointment"
                    type="button"
                    className="btn-round"
                    onClick={openGet_appointment_by_slot}
                  >
                    <i className="bi bi-download"></i> Get Slot Appointment
                  </button>
                </div>
                <div
                  className="col-md-2"
                  style={{ cursor: "pointer", padding: '5px' }}
                  onClick={handleDownloadClick}
                >
                  Download
                  <i
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    className="bi bi-download"
                  ></i>
                </div>
              </div>
            </div>

            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
              {isLoading ? (
                <div style={{ marginTop: "50px", marginLeft: "50%" }}>
                  <TailSpin color="black" width={50} />
                </div>
              ) : appointments.length > 0 ? (
                <table className="table table-striped">
                  <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
                    <tr>
                      <th scope="col">Sr.No</th>
                      <th scope="col">Name</th>
                      <th scope="col">Type</th>
                      <th scope="col">Gift</th>
                      <th scope="col">Appointment Date/Slot</th>
                      <th scope="col">Customer Details</th>
                      <th scope="col">Pass Details</th>
                      <th scope="col">Instructor/Venue Owner Details</th>
                      <th scope="col">No. of Tickets</th>
                      <th scope="col">Payment Amount</th>
                      <th scope="col">Booking Date Time</th>
                      <th scope="col">Status</th>
                      <th scope="col">Source</th>
                      <th scope="col">Attended</th>
                      <th scope="col">Cancellation Reason</th>
                      <th scope="col">Report</th>
                      <th scope="col">Rescheduled</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody id="tableBody">
                    {appointments.map((appointment, index) => (
                      <tr 
                        key={`${appointment.id}-${index}`}
                        ref={index === appointments.length - 1 ? lastAppointmentElementRef : null}
                        style={{
                          backgroundColor:
                            !appointment.attended &&
                            isWithin7Days(
                              appointment.type === "Workshop"
                                ? appointment.workshopSlot?.date
                                : appointment.bookingSlot?.startDate
                            )
                              ? 'rgba(255, 255, 0, 0.2)'
                              : 'inherit'
                        }}
                      >
                        <th scope="row">{(pagination.current_page - 1) * 50 + index + 1}</th>
                        <td>
                          {appointment.type === "Venue" ? (
                            <>{appointment.bookingSlot?.venue.name || "--"}</>
                          ) : (
                            <>
                              {appointment.workshopSlot?.workshop.name || "--"}
                            </>
                          )}
                          <br />
                        </td>
                        <td>
                          {appointment.type || "--"}
                          <br />
                        </td>
                        <td>
                          {appointment.gift?.name
                            ? appointment.gift.name.split(",").map((word, index) => (
                                <span key={index}>
                                  {word}
                                  <br />
                                </span>
                              ))
                            : "--"}
                          <br />
                          {appointment.gift?.mobileNumber
                            ? appointment.gift.mobileNumber.split(",").map((word, index) => (
                                <span key={index}>
                                  {word}
                                  <br />
                                </span>
                              ))
                            : "--"}
                          <br />
                          {appointment.gift?.email
                            ? appointment.gift.email.split(",").map((word, index) => (
                                <span key={index}>
                                  {word}
                                  <br />
                                </span>
                              ))
                            : "--"}
                          <br />
                        </td>
                        <td>
                          Date:
                          {appointment.type === "Workshop" ? (
                            <>
                              {formatCreatedAt(
                                appointment.workshopSlot?.date || "--"
                              )}
                            </>
                          ) : (
                            <>
                              {formatCreatedAt(
                                appointment.bookingSlot?.startDate || "--"
                              )}
                            </>
                          )}
                          <br />
                          Slot:{" "}
                          {convertTimeTo12HourFormat(appointment?.slot || "--")}
                          <br />
                          <br />
                        </td>
                        <td>
                          {appointment.user.name || "--"}
                          <br />
                          {appointment.user.email || "--"}
                          <br />
                          {appointment.user.mobileNumber || "--"}
                        </td>
                        <td>
                          {appointment.passes?.title || "--"}
                          <br />
                          {appointment.passes?.duration_type || "--"}
                        </td>
                        <td>
                          {appointment.type === "Workshop" ? (
                            <>
                              {appointment.workshopSlot?.workshop
                                .workshopInstructor.name || "--"}
                              <br />
                              {appointment.workshopSlot?.workshop
                                .workshopInstructor.email || "--"}
                              <br />
                              {appointment.workshopSlot?.workshop
                                .workshopInstructor.mobileNumber || "--"}
                            </>
                          ) : (
                            <>
                              {appointment.bookingSlot?.venue.venue_owner
                                .name || "--"}
                              <br />
                              {appointment.bookingSlot?.venue.venue_owner
                                .email || "--"}
                              <br />
                              {appointment.bookingSlot?.venue.venue_owner
                                .mobileNumber || "--"}
                            </>
                          )}
                        </td>
                        <td>
                          {appointment.numberOfTickets || "--"}
                        </td>
                        <td>
                          {appointment.transaction?.amount || appointment?.price || "--"}
                        </td>
                        <td>
                          {formatDateTime(new Date(appointment.created_at))}
                        </td>
                        <td style={{
                          color: appointment.status === "Active" ? 'green' : 
                               appointment.status === "Rescheduled" ? 'blue' : 'red',
                          fontWeight: 'bold'
                        }}>
                          {appointment.status || "-"}
                        </td>
                        <td>
                          {appointment.source || "Website"}
                        </td>
                        <td>
                          {appointment.status !== "Active" && (
                            <span
                              style={{
                                color: appointment.attended
                                  ? 'green'
                                  : appointment.not_attended
                                  ? 'red'
                                  : 'black',
                                fontWeight: 'bold'
                              }}
                            >
                              {appointment.attended
                                ? 'Attended'
                                : appointment.not_attended
                                ? 'Absent'
                                : '-'}
                            </span>
                          )}
                        </td>
                        <td>{appointment.reasonOfCancellation || "-"}</td>
                        <td>{appointment.report_text || "-"}</td>
                        <td>{appointment.rescheduled ? appointment.rescheduled : "No"}</td>
                        <td>
                          <button
                            id="btnNewUserCancel"
                            type="button"
                            className="btn-round"
                            onClick={() => openReport(appointment.id)}
                            style={{ marginRight: '5px', marginBottom: '5px' }}
                          >
                            <i></i> Report
                          </button>
                          <button
                            id="btnReschedule"
                            type="button"
                            className="btn-round"
                            onClick={() => openReschedule(appointment.id)}
                          >
                            <i></i> Reschedule
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <h3 style={{ textAlign: "center" }}> No data available </h3>
              )}

              {isFetching && (
                <div className="text-center py-3">
                  <TailSpin color="#0d6efd" width={50} />
                </div>
              )}
            </div>

            <div className="p-3 bg-dark text-white rounded-bottom">
              Showing {appointments.length} of {totalItems} total appointments
              {hasMore && " - scroll to load more"}
            </div>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default Appointment;